/**
 * Serviço de Ocorrências de alunos (Auth Service / FastAPI).
 */

import { apiServiceClient } from "../config/api";

const buildQuery = (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.nucleoId) params.append("nucleo_id", String(filters.nucleoId));
  if (filters.alunoId) params.append("aluno_id", String(filters.alunoId));
  if (filters.tipo) params.append("tipo", String(filters.tipo));
  if (filters.dataInicio) params.append("data_inicio", String(filters.dataInicio));
  if (filters.dataFim) params.append("data_fim", String(filters.dataFim));
  if (filters.limit != null) params.append("limit", String(filters.limit));
  if (filters.offset != null) params.append("offset", String(filters.offset));
  const qs = params.toString();
  return qs ? `?${qs}` : "";
};

export const ocorrenciasService = {
  async list(filters = {}) {
    return apiServiceClient.get(`/api/ocorrencias${buildQuery(filters)}`);
  },

  async listByAluno(alunoId, options = {}) {
    const params = new URLSearchParams();
    if (options.limit != null) params.append("limit", String(options.limit));
    if (options.offset != null) params.append("offset", String(options.offset));
    const qs = params.toString();
    return apiServiceClient.get(
      `/api/ocorrencias/aluno/${encodeURIComponent(alunoId)}${qs ? `?${qs}` : ""}`
    );
  },

  async getById(id) {
    return apiServiceClient.get(`/api/ocorrencias/${encodeURIComponent(id)}`);
  },

  async create(payload) {
    return apiServiceClient.post("/api/ocorrencias", payload);
  },

  async update(id, payload) {
    return apiServiceClient.patch(`/api/ocorrencias/${encodeURIComponent(id)}`, payload);
  },

  async delete(id) {
    return apiServiceClient.delete(`/api/ocorrencias/${encodeURIComponent(id)}`);
  },
};
